import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Cell, List, Row } from '../../../components/List';
import { Loader } from '../../../components/Loader';
import { GET_MY } from '../../../containers/App/constants';
import { CompanyLabelById } from '../../Companies/components/CompanyLabelById';
import { KanbanBoardDetails } from './details';
import { KanbanBoardEdit } from './edit';
import { KanbanBoardsOverview } from './overview';
import { KanbanBoardTest } from './test';

const Container = styled.div``;

/* eslint-disable react/prefer-stateless-function */
class KanbanBoardsTmp1Comp extends BaseComponent {
  constructor(props) {
    super(props, {});
  }

  componentDidMount() {
    this.props.fetch(result => {
      this.setState({ companies: result.companies });
    });
  }

  render() {
    if (!this.state.companies?.length) return null;

    return (
      <Container>
        <List>{this.state.companies.map(this.renderCompany.bind(this))}</List>
      </Container>
    );
  }

  renderCompany(id) {
    return (
      <Row key={id} onClick={this.tofn(`/companies/${id}`)}>
        <Cell>{id}</Cell>
        <Cell>
          <CompanyLabelById company_id={id} />
        </Cell>
      </Row>
    );
  }
}

KanbanBoardsTmp1Comp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch(callback) {
      dispatch({
        type: GET_MY,
        gate: 'tmp1',
        path: `boards/tmp/company1`,
        callback,
      });
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const KanbanBoardsTmp1 = compose(
  withConnect,
  withRouter,
)(KanbanBoardsTmp1Comp);
